<template>
    <Overlay :show="showOverlay">
        <b-card no-body :border-variant="borderVariant">
            <div class="card-header">
                <div class="w-100">
                    <b-card-title id="popover-button-1">{{ title }}</b-card-title>
                </div>
                <div v-if="parentTitle">
                    <b-icon-folder/>
                    <span class="text-less-muted" style="font-size: 0.9rem; padding-left: 4px;">{{ parentTitle }}</span>
                </div>
            </div>
            <CountrySelector
                :key="'pmo' + product.id"
                :label="countryLabel"
                class="ml-1 mr-1"
                :selected="product.countryOfOrigin"
                @input="onChange"
            />
        </b-card>
    </Overlay>
</template>

<script>
import { BCard, BCardTitle, BIconFolder } from 'bootstrap-vue'
import Overlay from "@core/components/common/Overlay";
import {CountrySelector} from "@core/components/supply-chain";
import {ProductProvider} from "@core/domain/product";

export default {
    components: {BCard, BCardTitle, BIconFolder, Overlay, CountrySelector},
    props: {
        product: {
            require: true
        },
        title: {
            require: true
        },
        parentTitle: {
            default: null
        }
    },
    data() {
        return {
            showOverlay: false,
            countryLabel: this.$t('Page(ReceivedRequest):Component(ProductManufacturingOrigin):label-country-of-origin')
        };
    },
    methods: {
        onChange(country) {
            this.showOverlay = true
            const product = ProductProvider(this.product.id);
            product
                .getCard()
                .then(card => {
                    card.countryOfOrigin = country;
                    this.product.countryOfOrigin = country;
                    return product.saveCard();
                })
                .then(() => {
                    this.$emit('updated');
                })
                .finally(() => this.showOverlay = false)
        }
    },
    computed: {
        borderVariant() {
            return this.product.countryOfOrigin && this.product.countryOfOrigin.id ? 'success' : 'default';
        }
    }
}
</script>
